// External libraries
import React from 'react';
import { useStoreState } from '@/store';

// Internal modules
import type { InputOnChange } from '@/types';
import { buildMPPUrl, getContent, hasSelectAllSignupTerms } from '@/lib';
import { getMarketingOptinContentKey } from './utils';
import { Checkbox, Link } from '@/components/Common';
import { MARKETING_OPT_IN } from '@/lib/features/constants';

const getTermsLinks = () => ({
  moreInformationLink: (
    <Link
      href={buildMPPUrl({ mppPath: 'paypal-and-your-data' })}
      text={getContent('compliance.moreInformation')}
    />
  ),
});

type MarketingOptInProps = {
  changeHandler: InputOnChange;
};

const MarketingOptIn = ({
  changeHandler,
}: MarketingOptInProps): JSX.Element => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const marketingOptIn = useStoreState(({ form }) => form[MARKETING_OPT_IN]);
  const isSelectAllExperience = hasSelectAllSignupTerms();
  const content = getMarketingOptinContentKey({ isSelectAllExperience });

  return (
    <Checkbox
      changeHandler={changeHandler}
      checked={marketingOptIn.value}
      disabled={isFormSubmitting}
      testID={MARKETING_OPT_IN}
      id={MARKETING_OPT_IN}
      label={getContent(content, getTermsLinks())}
      isTermsCheckbox
      name={MARKETING_OPT_IN}
    />
  );
};

export { MarketingOptIn };
